// extracted by mini-css-extract-plugin
export default {"container":"styles_container__i+jr8","sideLeft":"styles_sideLeft__7e7IC","sideRight":"styles_sideRight__1YwMe"};